import getConfig from 'next/config'

import { CustomersClient } from '@Protos/customers/customers_pb_service'

const { publicRuntimeConfig } = getConfig()

let clientSingleton: CustomersClient

export const getCustomersClient = (): CustomersClient => {
  if (clientSingleton) {
    return clientSingleton
  }

  clientSingleton = new CustomersClient(publicRuntimeConfig.apiEndpoint)

  return clientSingleton
}
